import { jsx as c } from "react/jsx-runtime";
import a from "./chunk547.js";
import { clsx as l } from "clsx";
const f = (s) => {
  const { type: t = "medium", children: r, className: m, ...o } = s, e = l(a[t], m);
  return /* @__PURE__ */ c("h1", { className: e, ...o, children: r });
};
export {
  f as H1
};
